import ready from "./lib/ready";
import promiseIdle from "./lib/promise-idle";
import {mutate} from "./lib/promise-fastdom";
import ToggleArea from "./lib/ToggleArea";
import {ButtonBehavior} from "./lib/ToggleArea_ButtonBehavior";
import {SizeTransitionBehavior} from "./lib/ToggleArea_SizeBehavior";

ready()
    .then(promiseIdle())
    .then(mutate(function () {
        document.querySelectorAll('.content__collapsed').forEach(node => {
            const button = document.createElement('button');
            button.type = 'button';
            button.classList.add('content__collapsed-ctrl');
            button.innerText = node.dataset.buttonLabel;
            node.insertAdjacentElement('afterend', button);

            new ToggleArea(node, 'collapsed', [
                new ButtonBehavior(button, {
                    closeOnBlur: false,
                    closeOnEsc: false,
                    closeOnLinkClick: false,
                    closeOnOutsideClick: false,
                    jail: false,
                    openedOnIni: true,
                }),
                new SizeTransitionBehavior(['height']),
            ]);
        });
    }));